import { useId } from "react";
import { useLocale } from "@/locale/LocaleContext";
import { LOCALES, type Locale } from "@/locale";
import styles from "./ui.module.css";

export function LanguageSwitch({ className }: { className?: string }) {
  const { locale, setLocale, m } = useLocale();
  const selectId = useId();

  return (
    <div className={[styles.langSwitch, className].filter(Boolean).join(" ")}>
      <label htmlFor={selectId} className="sr-only">
        {m.lang.switchLabel}
      </label>
      <select
        id={selectId}
        className={styles.langSelect}
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
        aria-label={m.lang.switchLabel}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {code === "en" ? m.lang.en : m.lang.de}
          </option>
        ))}
      </select>
    </div>
  );
}
